export const TOPICS_PLUGIN_ID = "topics";
export const TOPIC_ENTITY_TYPE = "topic";
export const TOPICS_BATCH_COMPLETED_EVENT = "topics:batch-completed";

export const KNOWLEDGE_MAP_DATASOURCE_ID = "topics:knowledge-map";
